/* eslint-disable class-methods-use-this */
/* global document */
import { dataValueToString, } from './proc_gen_wrapper';
export const getTmplDevArgs = (elem) => {
    const node = elem;
    // eslint-disable-next-line no-return-assign
    return (node._$wxTmplDevArgs = node._$wxTmplDevArgs || {});
};
const noop = () => {
    /* empty */
};
export class ProcGenWrapperDom {
    constructor(shadowRoot, procGen) {
        // set id
        this.i = (elem, v) => {
            this.shadowRoot.idMap[v] = elem;
        };
        // set event handler
        this.v = (elem, evName, v, final) => {
            const listener = (ev) => {
                const ret = this.shadowRoot.comp.callMethod(v, ev);
                if (final)
                    return false;
                return ret;
            };
            Object.defineProperty(listener, 'name', {
                value: v,
            });
            this.shadowRoot.setListener(elem, evName, listener);
        };
        // update a attribute
        this.a = (elem, name, v) => {
            this.r(elem, name, v);
        };
        this.shadowRoot = shadowRoot;
        this.procGen = procGen;
    }
    create(data) {
        const { shadowRoot, procGen } = this;
        const children = procGen(this, true, data);
        this.handleChildrenCreation(children.C, shadowRoot.shadowRootElement);
        return children.B;
    }
    bindingMapUpdate(field, data, bindingMapGenList) {
        const updaters = bindingMapGenList[field];
        if (updaters === undefined)
            return;
        for (let i = 0; i < updaters.length; i += 1) {
            const bindingMapGen = updaters[i];
            bindingMapGen(data, () => {
                /* empty */
            }, (elem, v) => {
                ;
                elem.textContent = v;
            });
        }
    }
    handleChildrenCreation(children, parentNode) {
        let slotMergeable = true;
        let slotMerged = false;
        const appendSlot = () => {
            slotMergeable = false;
            slotMerged = false;
            const elem = document.createElement('virtual');
            parentNode.appendChild(elem);
            this.shadowRoot.slot = elem;
        };
        children(true, 
        // text node
        (textContent, textInit) => {
            if (slotMerged)
                appendSlot();
            else
                slotMergeable = false;
            const elem = document.createTextNode(textContent || '');
            if (textInit)
                textInit(elem);
            parentNode.appendChild(elem);
        }, 
        // component or native node
        (tagName, genericImpls, propertyInit, children) => {
            if (slotMerged)
                appendSlot();
            else
                slotMergeable = false;
            const elem = document.createElement(tagName);
            propertyInit(elem, true);
            this.handleChildrenCreation(children, elem);
            parentNode.appendChild(elem);
        }, 
        // wx:if node or template-is node
        noop, 
        // wx:for node
        noop, 
        // slot node
        () => {
            if (slotMergeable) {
                slotMerged = true;
                this.shadowRoot.slot = parentNode;
            }
            else {
                appendSlot();
            }
        }, 
        // other virtual node
        (children) => {
            if (slotMerged)
                appendSlot();
            else
                slotMergeable = false;
            const elem = document.createElement('virtual');
            this.handleChildrenCreation(children, elem);
            parentNode.appendChild(elem);
        });
    }
    // set slot
    s() {
        noop();
    }
    // set slot value
    l() {
        noop();
    }
    // set class or external classes named `class`
    c(elem, v) {
        elem.setAttribute('class', v);
    }
    // set a list of classes and use previous value if an item is null
    e() {
        noop();
    }
    // set a single class in the list of classes (should only be used in binding-map updates)
    ei() {
        noop();
    }
    // set style or property named `style`
    y(elem, v) {
        elem.setAttribute('style', v);
    }
    // set a list of styles and use previous value if an item is null
    w() {
        noop();
    }
    // set a single style value in the list of styles (should only be used in binding-map updates)
    wi() {
        noop();
    }
    // set dataset
    d(elem, name, v) {
        elem.dataset[name] = dataValueToString(v);
    }
    // set mark
    m() {
        noop();
    }
    // update a property or external class of a component, or an attribute of a native node
    r(elem, name, v) {
        if (typeof v === 'boolean') {
            if (v)
                elem.setAttribute(name, '');
            else
                elem.removeAttribute(name);
        }
        else {
            elem.setAttribute(name, dataValueToString(v));
        }
    }
    // set a worklet directive value
    wl() {
        noop();
    }
    // add a change property binding
    p() {
        noop();
    }
    // set filter functions for change properties and event listeners
    setFnFilter() {
        noop();
    }
    // set event listener wrapper
    setEventListenerWrapper() {
        noop();
    }
    // get dev args object
    devArgs(elem) {
        return getTmplDevArgs(elem);
    }
}
//# sourceMappingURL=proc_gen_wrapper_dom.js.map